import React from 'react';

import { Link } from '@lt/components';
import { Trans } from '@lt/localization';

import { Container } from 'src/components/ValidationErrorsList';

interface Props {
  isVisible: boolean;
  onClick: () => void;
}

/**
 * Компонент выводит сообщение о падении ручки /tourists/validate
 */
export const ValidationRequestFailed = (props: Props) => {
  const { isVisible, onClick } = props;

  if (!isVisible) return null;

  const handleClick = (e) => {
    e.preventDefault();
    onClick();
  };

  return (
    <Container>
      <Trans
        i18nKey="checkout.touristForm.warning.validationRequestFailed"
        components={{
          Link: <Link href="#" onClick={handleClick} />,
        }}
      />
    </Container>
  );
};
